module.exports = __webpack_public_path__ + "static/media/game-display-4@2x.50e951ad.png";